<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.setting') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-sec-head">Account</div>
        <div class="km-card">
          <button class="km-row" @click="toInfomation()">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#ff6b9d,#ff4d8d)">👤</span>
            <span class="km-row__lbl">{{ $t('setting.base_setting') }}</span>
            <span class="km-row__chev">›</span>
          </button>
          <button class="km-row" @click="toLoginPassword()">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#60a5fa,#3b82f6)">🔒</span>
            <span class="km-row__lbl">{{ $t('setting.login_pwd') }}</span>
            <span class="km-row__chev">›</span>
          </button>
          <button class="km-row" @click="toPayPassword()">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#fbbf24,#f59e0b)">🔐</span>
            <span class="km-row__lbl">{{ $t('setting.finance_pwd') }}</span>
            <span class="km-row__val" :class="{ ok: hasPayPw, missing: !hasPayPw }">{{ userInfo.paypassword }}</span>
            <span class="km-row__chev">›</span>
          </button>
          <button class="km-row" @click="toLanguage()">
            <span class="km-row__ico" style="background:linear-gradient(135deg,#34d399,#10b981)">🌐</span>
            <span class="km-row__lbl">{{ $t('setting.language') }}</span>
            <span class="km-row__chev">›</span>
          </button>
        </div>
      </section>

      <section class="km-section">
        <button class="km-btn km-btn--danger" @click="loginout()">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
          {{ $t('setting.logout') }}
        </button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { userInfo: {} }; },
  computed: {
    hasPayPw() {
      return this.userInfo.paypassword === this.$t("setting.y_setting");
    }
  },
  methods: {
    back() { return window.history.back(); },
    toPayPassword() {
      if (this.userInfo.paypassword !== this.$t("setting.no_setting")) this.$toast(this.$t("withdraw.with_service"));
      else this.$router.push({ path: '/SetPayPassword' });
    },
    toLoginPassword() { this.$router.push({ path: '/SetLoginPassword' }); },
    toLanguage() { this.$router.push({ name: 'Language', params: { "type": "setting" } }); },
    toInfomation() { this.$router.push({ path: '/Infomation' }); },
    loginout() { localStorage.clear(); this.$router.push({ path: '/Mine' }); },
    toServicePage() { this.$router.push("ServicePage"); },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (res.data.paypassword) this.userInfo.paypassword = this.$t("setting.y_setting");
          else this.userInfo.paypassword = this.$t("setting.no_setting");
        } else if (res.code === 401) this.$toast(res.msg);
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
</style>
